module.exports = __webpack_public_path__ + "static/media/pores_cheek.b59fd3ca.svg";